module.exports = __webpack_public_path__ + "img/hr-tree-07-a-leaves.26c5d7e6.png";